import * as Yup from 'yup';
import { ipv4Regex, ipv6Regex } from '../utils/regex';
export var officeValidation = Yup.object({
    ipAddress: Yup.string()
        .test('is-ip-address', 'Invalid IP address', function (value) { return ipv4Regex.test(value || '') || ipv6Regex.test(value || ''); })
        .required(),
});
